export class Client {
  constructor(public name: string) {}
}
